/**
 * Labstep
 *
 * @module components/ProtocolCollection/ListOrTable
 * @desc List or table of protocolCollections
 */

import { ProtocolCollectionList } from 'labstep-web/components/ProtocolCollection/List';
import { ProtocolCollectionTable } from 'labstep-web/components/ProtocolCollection/Table';
import { MasterIndexCenterListOrTableContainer as MasterIndexCenterListOrTable } from 'labstep-web/screens/Master/Index/Center/ListOrTable';
import type React from 'react';
import { actions } from './constants';
import type { IProtocolCollectionListOrTableProps } from './types';

export const ProtocolCollectionListOrTable: React.FC<
  IProtocolCollectionListOrTableProps
> = ({ protocolCollections, ...rest }) => (
  <MasterIndexCenterListOrTable
    tableComponent={
      <ProtocolCollectionTable
        showCollaborators
        actions={actions}
        protocolCollections={protocolCollections}
        {...rest}
      />
    }
    listComponent={
      <ProtocolCollectionList
        actions={actions}
        protocolCollections={protocolCollections}
      />
    }
  />
);
